import VeroLogo from '../assets/Vero'

const vero = {
  getImage: (props) => <VeroLogo className="vero newLogo" {...props} />,
}

export default vero
